module.exports = __webpack_public_path__ + "static/img/logo_login.f276e4a4.png";